import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthTokensService } from '../../../../web/modern/auth-tokens.service';
import {
	PaymentSchedule,
	PaymentScheduleRequest,
	PaymentScheduleSettings,
	SavePaymentScheduleResponse
} from '@models/invoice.model';

@Injectable()
export class PaymentSchedulesDataProvider {
	constructor(
		private http: HttpClient,
		private tokenService: AuthTokensService
	) {}

	getPaymentScheduleOptions(): Observable<any> {
		/* headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		} */
		const url = '/protected/rest/payment_schedule_options';
		return this.http.get(url);
	}

	getPaymentScheduleSettings(): Observable<PaymentScheduleSettings> {
		const url = 'api/user/settings/payment-schedule/metadata';
		const token = this.tokenService.getAuthToken();

		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`
		});
		const options = { headers };
		return this.http.get<PaymentScheduleSettings>(url, options);
	}

	createPaymentSchedule(
		data: PaymentScheduleRequest
	): Observable<SavePaymentScheduleResponse> {
		const url = '/api/user/settings/payment-schedules/create';
		return this.http.post<SavePaymentScheduleResponse>(url, data);
	}

	updatePaymentSchedule(
		data: PaymentScheduleRequest
	): Observable<SavePaymentScheduleResponse> {
		const url = `/api/user/settings/payment-schedules/${data.id}/update`;
		return this.http.post<SavePaymentScheduleResponse>(url, data);
	}

	deletePaymentSchedule(data): Observable<any> {
		const url = '/protected/rest/payment_schedule/delete';
		return this.http.post(url, data);
	}

	getPaymentsSchedules(params): Observable<any> {
		const url = '/protected/rest/company_payment_schedules';
		return this.http.get(url, { params });
	}

	getPaymentSchedule(id: string): Observable<PaymentSchedule> {
		const url = '/protected/rest/payment_schedule';
		const params = new HttpParams().append('paymentScheduleId', id);
		return this.http.get<PaymentSchedule>(url, { params });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts